import { useTranslation } from '@packlink/translation-provider';
import { SettingsPageHeader } from '@common/components/SettingsPage';
import { TabList } from '@shipengine/giger';
import { RouterTab } from '@router/components/RouterTab/RouterTab';
import { getTabListStyles } from './BrandedEmailsSettingsNavBarStyles';
import { APP_ROUTE } from '@router/routes';
import { useAmplitude } from '@common/hooks';
import { AmplitudeEvents } from '@constants/amplitude';

enum tabIds {
    EMAIL_TEMPLATES = 'emailTemplates',
    BRAND_SETTINGS = 'brandSettings',
}
export function BrandedEmailsSettingsNavBar(): JSX.Element {
    const { t } = useTranslation();
    const { sendAmplitudeClickEvent } = useAmplitude();

    const handleTabClick = (selectedItem: string | undefined) => {
        const event =
            selectedItem === tabIds.EMAIL_TEMPLATES ? AmplitudeEvents.EMAIL_TEMPLATES : AmplitudeEvents.BRAND_SETTINGS;
        sendAmplitudeClickEvent(event);
    };

    return (
        <>
            <SettingsPageHeader>{t('branded-emails.settings.title')}</SettingsPageHeader>
            <TabList css={getTabListStyles}>
                <RouterTab
                    tabId={tabIds.EMAIL_TEMPLATES}
                    text={t('settings.branded-emails.tab-email-templates')}
                    to={APP_ROUTE.SETTINGS.BRANDED_EMAILS_EMAIL_TEMPLATES}
                    onClick={handleTabClick}
                >
                    {t('settings.branded-emails.tab-email-templates')}
                </RouterTab>

                <RouterTab
                    tabId={tabIds.BRAND_SETTINGS}
                    text={t('settings.branded-emails.tab-brand-settings')}
                    to={APP_ROUTE.SETTINGS.BRANDED_EMAILS_BRAND_SETTINGS}
                    onClick={handleTabClick}
                >
                    {t('settings.branded-emails.tab-brand-settings')}
                </RouterTab>
            </TabList>
        </>
    );
}
